import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useGroupCodesList() {

    //User toast
    
    const toast = useToast()

    const refGroupCodeListTable = ref(null)

    const tableColumns = [
        {key: 'group_code', label: '集團代號',sortable: true},
        {key: 'name_of_group', label: '集團名稱',sortable: true},
        {key: 'description', label: '描述'},
        {key: 'action', label: '操作'}
    ]

    const perPage = ref(10)
    const totalGroupCodes = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refGroupCodeListTable.value ? refGroupCodeListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalGroupCodes.value,
        }
    })

    const refetchData = () => {
        refGroupCodeListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchGroupCodes = (ctx, callback) => {
        store.dispatch('client-groupcode/fetchGroupCodes',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {groupcodes, total} = response.data
            callback(groupcodes)
            totalGroupCodes.value = total
        
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching group codes list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchGroupCodes,
        tableColumns,
        perPage,
        currentPage,
        totalGroupCodes,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refGroupCodeListTable,
        ability,
        refetchData
    }

}